import { Component, OnInit } from '@angular/core';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit {

    loading!: boolean
    uploading!: boolean
    message!: string

    constructor(private loaderService: LoaderService) {
        this.loaderService.isLoading.subscribe((v) => {
            setTimeout(() => {
                this.loading = v;
            });
        });
        this.loaderService.isUploading.subscribe((v) => {
            setTimeout(() => {
                this.uploading = v.status;
                this.message = v.message;
            });
        });
    }

    ngOnInit() {
    }

}